/**
 * LearningLab Domain — Barrel Export
 *
 * Public API for the learningLab domain: practice mode selection,
 * family picking, mission briefing, and challenge acceptance.
 *
 * Created in s57 (DDD co-locatie — True DDD).
 * Moved from src/components/learningLab/ to src/learningLab/.
 *
 * Architecture:
 * - LearningLabPage: Main orchestrator page
 * - LabStation: Individual mode card
 * - MissionBriefing: Djay's personalized recommendations
 * - FamilyPicker: Full-screen family selection
 * - modals/: ChallengeAcceptModal, ModeIntroSheet, FluencyModulePicker
 * - shared/: CardSurface, modeTheme, ContinueStrip, LabHero, NewlyUnlockedBanner
 * - hooks/: useModeFlow, useLabPersonalization, useLabData
 */

// ── Pages ────────────────────────────────────────────────────
export { LearningLabPage } from './LearningLabPage';

// ── Components ───────────────────────────────────────────────
export { LabStation } from './LabStation';
export { MissionBriefing } from './MissionBriefing';
export { FamilyPicker } from './FamilyPicker';
export type { FamilyPickerMode } from './FamilyPicker';

// ── Modals ───────────────────────────────────────────────────
export { ChallengeAcceptModal } from './modals/ChallengeAcceptModal';
export { FluencyModulePicker } from './modals/FluencyModulePicker';
export { ModeIntroSheet } from './modals/ModeIntroSheet';

// ── Shared ───────────────────────────────────────────────────
export { MODE_THEME } from './shared/modeTheme';
export type { ModeId, ModeTheme } from './shared/modeTheme';